export default __webpack_public_path__ + "static/media/birthday_high.f08422b9.png";